module.exports = __webpack_public_path__ + "static/media/kake_grey-min.1ae77884.png";